module.exports = "/_next/static/images/46256189f4a5905d64a0235d16a6ebcc-notaxes@1x.jpg.webp";